// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"61":"2b1b6fce","122":"2b1b6fce","169":"2b1b6fce","180":"2b1b6fce","243":"2b1b6fce","331":"2b1b6fce","389":"4c23d71c","615":"2b1b6fce","752":"2b1b6fce","780":"2b1b6fce","795":"2b1b6fce","900":"2b1b6fce","912":"2b1b6fce"}[chunkId] + ".chunk.css";
};